import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stimulation',
  templateUrl: './stimulation.component.html',
  styleUrls: ['./stimulation.component.css']
})
export class StimulationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
